import styled from 'styled-components';

import { gray7, blue500 } from './Const';

export const TemplateHeroOffset = styled.div.attrs(props => {
    return {
        className: props.className,
    };
})`
  z-index: 2;
  padding-top: 0;

   @media (min-width: 992px) {
       padding-top: 30px;
   }
`;

export const DescriptionBottom = styled.p`
    color: white;
`;


interface TemplateHeroStyleProps {
    headerColor: string;
};

export const TemplateHero = styled.div<TemplateHeroStyleProps>`
    background-color: ${(props: TemplateHeroStyleProps) => props.headerColor};
    overflow: auto;
    border-radius: 0 0 3px 3px;
    margin-top: 12px;
    margin-bottom: 36px;

    @media (min-width: 992px) {
            margin-top: 32px;
            margin-bottom: 72px;
    }

    @media (min-width: 1200px) {
        border-radius: 0;
    }
`;

export const CategoryName = styled.h1`
    color: white;
    line-height: 50px;
    font-size: 40px;

    @media (min-width: 768px) {
        line-height: 54px;
        font-size: 48px;
    }

    @media (min-width: 1200px) {
        line-height: 72px;
        font-size: 60px;
    }
`;

export const GalleryTabsContainer = styled.div`
    display: flex;
`;

export const GalleryTab = styled.a.attrs(props => {
    return {
        className: props.className,
    };
})`
    padding: 11px 28px;
    background: rgba(243, 245, 249, 0.24);
    border-radius: 4px 4px 0px 0px;
    margin-right: 12px;
    color: white;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    transition: 0.2s ease-in-out;

    &.active {
        background: ${gray7};
        color: ${blue500};
        text-decoration: none;
    }

    &:not(.active):hover {
        text-decoration: none;
        background: rgba(243, 245, 249, 0.52);
        cursor: pointer;
        color: white;
    }
`;



// WEBPACK FOOTER //
// ./assets/js/styles/CategoryHeader.ts